module.exports = __webpack_public_path__ + "static/media/persian-tile.33858797.jpg";